var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetirementPensionSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2129_98)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3205 35.6197C33.6807 35.6197 33.1322 35.3946 32.6752 34.9446C32.2181 34.4946 31.9931 33.9462 32.0002 33.2993C31.9931 32.6664 32.2181 32.125 32.6752 31.675C33.1322 31.225 33.6807 31 34.3205 31C34.9393 31 35.4772 31.225 35.9342 31.675C36.3983 32.125 36.6339 32.6664 36.6409 33.2993C36.6339 33.7282 36.5214 34.1184 36.3034 34.47C36.0925 34.8216 35.8112 35.1028 35.4596 35.3138C35.1151 35.5177 34.7354 35.6197 34.3205 35.6197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2267 13C28.779 13 29.2267 13.4477 29.2267 14V34.9241C29.2267 35.4764 28.779 35.9241 28.2267 35.9241H25.6419C25.0896 35.9241 24.6419 35.4764 24.6419 34.9241V14C24.6419 13.4477 25.0896 13 25.6419 13H28.2267Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5848 13C21.1371 13 21.5848 13.4477 21.5848 14V34.9241C21.5848 35.4764 21.1371 35.9241 20.5848 35.9241H18C17.4477 35.9241 17 35.4764 17 34.9241V14C17 13.4477 17.4477 13 18 13H20.5848Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2129_98",
    x1: 1.06167e-7,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementPensionSavings);
export default __webpack_public_path__ + "static/media/RetirementPensionSavings.6fcc7e22a55f097293d42ee9ed382bcd.svg";
export { ForwardRef as ReactComponent };